<ideal-item-price [itemId]="itemId()" [multiplyBy]="quantity()" usePricePer="auto" sizing="compact" />
